module.exports = __webpack_public_path__ + "eedf85b57ff041d5ee3acb898e8fea57.MP3";